import {Alert} from "@mui/material";
import React from "react";
import {asDates, DateRangeOption} from "../../components/filter-fields/DateRangeFilter";
import {daysBetween, today} from "../../util/DateUtil";

export function VisitDataCoverageWarning({dates, dateRange}: {
    dates: string[],
    dateRange: DateRangeOption,
}) {
    const {from, to} = asDates(dateRange);
    const selectedTo = to ?? today();

    if (dates.length === 0) return (
        <Alert severity="warning" sx={{mb: 2}}>
            No visit data is available.
        </Alert>
    );

    if (!from && !to) return null;

    const firstAvailableDate = dates[0];
    const fromMessage = from != null && from < firstAvailableDate && {
        selected: from,
        days: daysBetween(from, firstAvailableDate),
        available: firstAvailableDate,
    };

    const lastAvailableDate = dates[dates.length - 1];
    const toMessage = selectedTo > lastAvailableDate && {
        selected: selectedTo,
        days: daysBetween(lastAvailableDate, selectedTo),
        available: lastAvailableDate,
    };

    if (!fromMessage && !toMessage) return null;

    return (
        <Alert severity="warning" sx={{mb: 2}}>
            Visit data does not cover the full selected period.{' '}
            {fromMessage && toMessage ? (
                <>
                    Selected period is {fromMessage.selected}–{toMessage.selected} and available visit data spans <b>{fromMessage.available}–{toMessage.available}</b>. Results are missing <b>{fromMessage.days + toMessage.days}</b> days.
                </>
                ) : fromMessage ? (
                <>
                    Selected period starts on {fromMessage.selected} and visit data is only available since <b>{fromMessage.available}</b>. Results are missing <b>{fromMessage.days}</b> days.
                </>
            ) : toMessage ? (
                <>
                    Selected period ends on {toMessage.selected} and visit data is only available until <b>{toMessage.available}</b>. Results are missing <b>{toMessage.days}</b> days.
                </>
            ) : null}
        </Alert>
    );
}
